import { Response } from 'src/types';

import { apiRequest } from '../api';
import { endpoints } from '../config';
import { RequestMethodEnum } from '../types';
import {
  AddCampaignRequest,
  AddCampaignSlotRequest,
  Campaign,
  CampaignDictionaries,
  CampaignListItem,
  CampaignSlot,
  EditCampaignRequest,
  EditCampaignSlotRequest,
} from './types';

export const getCampaigns = async (): Promise<CampaignListItem[]> => {
  const response = await apiRequest<Response<CampaignListItem[]>, void>(
    endpoints.campaigns.getAll,
    RequestMethodEnum.GET,
    {}
  );
  return response?.data || [];
};

export const getCampaign = async (
  id: number
): Promise<Campaign | undefined> => {
  const response = await apiRequest<Response<Campaign>, void>(
    endpoints.campaigns.getDetails(id),
    RequestMethodEnum.GET,
    {}
  );
  return response?.data;
};

export const addCampaign = async (
  data: AddCampaignRequest
): Promise<Campaign | undefined> => {
  const response = await apiRequest<Response<Campaign>, AddCampaignRequest>(
    endpoints.campaigns.add,
    RequestMethodEnum.POST,
    { data, showErrorMessage: true, showSuccessMessage: true }
  );
  return response?.data;
};

export const editCampaign = async (
  id: number,
  data: EditCampaignRequest
): Promise<Campaign | undefined> => {
  const response = await apiRequest<Response<Campaign>, EditCampaignRequest>(
    endpoints.campaigns.update(id),
    RequestMethodEnum.PATCH,
    { data, showErrorMessage: true, showSuccessMessage: true }
  );
  return response?.data;
};

export const deleteCampaign = async (
  id: number
): Promise<{ id: number } | undefined> => {
  const response = await apiRequest<Response<{ id: number }>, void>(
    endpoints.campaigns.delete(id),
    RequestMethodEnum.DELETE,
    {}
  );
  return response?.data;
};

export const addCampaignSlot = async (
  data: AddCampaignSlotRequest
): Promise<CampaignSlot | undefined> => {
  const response = await apiRequest<
    Response<CampaignSlot>,
    AddCampaignSlotRequest
  >(endpoints.campaigns.addSlot, RequestMethodEnum.POST, {
    data,
    showErrorMessage: true,
    showSuccessMessage: true,
  });
  return response?.data;
};

export const editCampaignSlot = async (
  id: number,
  data: EditCampaignSlotRequest
): Promise<CampaignSlot | undefined> => {
  const response = await apiRequest<
    Response<CampaignSlot>,
    EditCampaignSlotRequest
  >(endpoints.campaigns.editSlot(id), RequestMethodEnum.PATCH, {
    data,
    showErrorMessage: true,
    showSuccessMessage: true,
  });
  return response?.data;
};

export const deleteCampaignSlot = async (
  id: number
): Promise<{ id: number } | undefined> => {
  const response = await apiRequest<Response<{ id: number }>, void>(
    endpoints.campaigns.deleteSlot(id),
    RequestMethodEnum.DELETE,
    {}
  );
  return response?.data;
};

export const getCampaignDictionaries = async (): Promise<
  CampaignDictionaries | undefined
> => {
  const response = await apiRequest<Response<CampaignDictionaries>, void>(
    endpoints.campaigns.dictionaries,
    RequestMethodEnum.GET,
    {}
  );
  return response?.data;
};
